/**
 * Utility functions for highlighting template variables in content
 */

/**
 * Highlights template variables ({$variable_name}) with blue styling
 * @param content - The HTML content to process
 * @returns Content with highlighted variables
 */
export const highlightVariables = (content: string): string => {
  if (!content) return content;

  // Regex to match {$variable_name} patterns (MailerLite format)
  const variableRegex = /\{\$([^}]+)\}/g;

  // Replace variables with highlighted versions
  return content.replace(variableRegex, (match, variableName) => {
    return `<span style="background-color: #dbeafe !important; color: #1e40af !important; padding: 2px 4px; border-radius: 3px; font-weight: 500 !important; display: inline-block;">${match}</span>`;
  });
};

/**
 * Highlights template variables with custom styling
 * @param content - The HTML content to process
 * @param className - Custom CSS class name to apply
 * @returns Content with highlighted variables
 */
export const highlightVariablesWithClass = (content: string, className: string = 'variable-highlight'): string => {
  if (!content) return content;

  const variableRegex = /\{\$([^}]+)\}/g;

  return content.replace(variableRegex, (match, variableName) => {
    return `<span class="${className}">${match}</span>`;
  });
};

/**
 * Extracts all template variables from content
 * @param content - The content to search
 * @returns Array of variable names (without the {$} brackets)
 */
export const extractVariables = (content: string): string[] => {
  if (!content) return [];

  const variableRegex = /\{\$([^}]+)\}/g;
  const variables: string[] = [];
  let match;

  while ((match = variableRegex.exec(content)) !== null) {
    variables.push(match[1].trim());
  }

  // Remove duplicates
  return Array.from(new Set(variables));
};